module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/34_5859f97de0860d5bf9794437ae11f691.jpg";